import { useQuery } from '@tanstack/react-query';
import { DrafsCorrectiveActionResponse } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import IncidentReviewDrafts from '../../views/IncidentReviewDrafts';
import Loader from '../../components/Loader';

export default function IncidentReviewDraftsPage() {
  const { CorrectiveActionApi } = useApiClients();
  const { data, isLoading, isRefetching } = useQuery<
    DrafsCorrectiveActionResponse['correctiveActions']
  >({
    queryKey: ['review-all-drafts'],
    queryFn: async () => {
      const response =
        await CorrectiveActionApi.correctiveActionControllerGetDrafts();
      return response?.data.correctiveActions;
    },
  });

  if (isLoading || isRefetching) {
    return <Loader />;
  }

  return (
    <>
      <IncidentReviewDrafts
        draftReview={data as DrafsCorrectiveActionResponse['correctiveActions']}
      />
    </>
  );
}
